import { selectDefaultFolder } from 'owa-mail-folder-forest-actions';
import { showWebapplinkTestDialog } from 'native-host-protocol-ui';

/**
 * Route handler for the webapplink test route.
 * This function selects the default folder and shows the webapplink test dialog to help verify functionality of Web-to-App Links in Monarch
 */
export default function webapplinkTestRouteHandler(): void {
    selectDefaultFolder('Route');
    showWebapplinkTestDialog();
}
